import { Component, Input } from '@angular/core';
import { Tab } from '../mot-tabs/mot-tabs.component';

@Component({
    selector: 'mot-tab',
    templateUrl: './mot-tab.component.html',
    styleUrls: ['./mot-tab.component.scss'],
    standalone: false
})
export class MotTabComponent {
  @Input() tab: Tab;
}
